import React from 'react'
import classes from './styles.module.scss'
import { SettingsType } from '../../../models/SettingsType'

interface Props {
  firstUnreadMessageRef: any
  settings: SettingsType
}

export const NewMessagesLine: React.FC<Props> = ({
  firstUnreadMessageRef,
  settings,
}) => {
  return (
    <div
      className={classes.container}
      ref={firstUnreadMessageRef}
      style={{ borderColor: settings.color }}>
      <span style={{ color: settings.color }}>
        {settings.unreadMessagesTitle}
      </span>
    </div>
  )
}
